import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router, ParamMap } from '@angular/router';

import { AuthenticationService } from "../../../services/authentication/authentication.service";
import { Message } from 'primeng/components/common/api';
import {ForgotPasswordModel} from "../../../models/inModels/ChangePasswordModel";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
    model: ForgotPasswordModel;
	loading = false;
	messages: Message[];
    constructor(
	    private route: ActivatedRoute,
	    private router: Router,
	    private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.model = new ForgotPasswordModel();
	    this.route.paramMap.subscribe(params => {
		    this.model.UserName = params.get('UserName');
	    });
    }

	post(): void {
		this.loading = true;
		this.authenticationService.forgotPassword(this.model).then(
			result => {
				this.loading = false;
				this.messages = [];
				this.messages.push({ severity: 'success', summary: 'Success', detail: 'Password Reset Sent. Please check your emails and sms\'s. <br/> Look in your spam folder if you cant find the email.' });
			},
			error => {
				this.loading = false;
                this.messages = [];
                this.messages.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/manage/forgot-password/forgot-password.component.ts